import { render, staticRenderFns } from "./account_record_list.vue?vue&type=template&id=83861bf2&scoped=true"
import script from "./account_record_list.vue?vue&type=script&lang=js"
export * from "./account_record_list.vue?vue&type=script&lang=js"
import style0 from "./account_record_list.vue?vue&type=style&index=0&id=83861bf2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83861bf2",
  null
  
)

export default component.exports